// extracted by mini-css-extract-plugin
export default {"listing-item-container":"category-listing-item-component_listing-item-container__hNCjY","title":"category-listing-item-component_title__-QFhV"};